import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: 'getobject'
})
export class ObjectPropertyRetrieverPipe implements PipeTransform {
  transform(value: any, property: 'values' | 'keys') {
    if (property === "keys") {
      return Object.keys(value);
    } else {
      return Object.values(value);
    }
  }
}